import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getBreakoutTopic, getFeedCategories } from "../services/news-feed.services";
import { setFeedCategoriesData, setBreakCategoriesData } from "context/features/dataSlice";

const fetchingRef = { categories: false, breakout: false };

export const useGetFeedCategories = () => {
  const { user } = useSelector((state) => state.auth);
  const { feedCategoriesData, breakCategoriesData } = useSelector((state) => state.data);
  const dispatch = useDispatch();

  const fetchCategories = async () => {
    if (fetchingRef.categories || feedCategoriesData?.length > 0) return;
    fetchingRef.categories = true;
    try {
      const categories = await getFeedCategories(user.userId);
      dispatch(setFeedCategoriesData(categories));
    } catch (error) {
      console.error("Failed to fetch feed categories:", error);
    } finally {
      fetchingRef.categories = false;
    }
  };

  const fetchBreakoutTopics = async () => {
    if (fetchingRef.breakout || breakCategoriesData?.length > 0) return;
    fetchingRef.breakout = true;
    try {
      const categories = await getBreakoutTopic(user.userId);
      dispatch(setBreakCategoriesData(categories));
    } catch (error) {
      console.error("Failed to breakout topic list", error);
    } finally {
      fetchingRef.breakout = false;
    }
  };

  useEffect(() => {
    if (!feedCategoriesData?.length) {
      fetchCategories();
    }
    if (!breakCategoriesData?.length) {
      fetchBreakoutTopics();
    }
  }, [feedCategoriesData, breakCategoriesData, user.userId]);

  return {
    feedCategories: feedCategoriesData || [],
    breakCategories: breakCategoriesData || []
  };
};
